import React, {ReactElement} from 'react';
import MidScreenModal, {ModalAnimateDirection} from './MidScreenModal';

type confirmModalType = {
  title?: string;
  message: string;
  open?: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const ConfirmModal = ({
  onClose,
  open,
  message,
  title,
  onCancel,
  onConfirm,
}: confirmModalType): ReactElement => {
  return (
    <div>
      <MidScreenModal
        isVisible={open}
        onClose={onClose}
        setbackopacity="bg-opacity-50"
        animate
        animateDirection={ModalAnimateDirection.BOTTOM_TO_TOP}>
        <div className="">
          <div className="p-4">
            <div className="text-2xl">{title}</div>
            <div className="mt-6 text-base">{message}</div>
          </div>
          <div className="border-t border-light_grey border-opacity-10">
            <button
              className="p-4 w-1/2 text-black_zero font-bold focus:outline-none"
              onClick={onCancel}>
              No
            </button>
            <button
              className="p-4 w-1/2 border-l border-light_grey border-opacity-10 text-royal_blue font-bold focus:outline-none"
              onClick={onConfirm}>
              Yes
            </button>
          </div>
        </div>
      </MidScreenModal>
    </div>
  );
};

export default ConfirmModal;
